const actions = {
  updateDays({ state, commit, dispatch }, { index, value }) {
    let formData = state.calcs[index];
    if (formData === undefined) {
      formData = {
        index,
        days: value,
        miles: 0,
        annualMileage: 0,
      };
    } else {
      formData.days = value;
    }
    commit('updateData', formData);
    dispatch('annualCalc', { index });
  },
  updateMiles({ state, commit, dispatch }, { index, value }) {
    let formData = state.calcs[index];
    if (formData === undefined) {
      formData = {
        index,
        days: 0,
        miles: value,
        annualMileage: 0,
      };
    } else {
      formData.miles = value;
    }
    commit('updateData', formData);
    dispatch('annualCalc', { index });
  },
  loadMiles({ state, commit, dispatch }, { index, value, action }) {
    const formData = state.calcs[index];
    formData.miles = value;
    commit('updateData', formData);
    if (action === 'input') {
      dispatch('updateMiles', { index, value });
    }
  },
  loadDays({ state, commit, dispatch }, { index, value, action }) {
    const formData = state.calcs[index];
    formData.days = value;
    commit('updateData', formData);
    if (action === 'input') {
      dispatch('updateDays', { index, value });
    }
  },
  annualCalc({ state, commit }, obj) {
    const formData = state.calcs[obj.index];
    if (obj.value) {
      formData.annualMileage = obj.value;
      commit('updateData', formData);
    } else {
      if (!formData.days || !formData.miles) {
        formData.annualMileage = '';
      } else {
        formData.annualMileage = (100 * formData.days * formData.miles) + 5200;
      }
      commit('updateData', formData);
    }
  },
};

const mutations = {
  updateData(state, dataObj) {
    state.calcs[dataObj.index] = dataObj;
  },
  setAnnual(state, newValue) {
    state.annualMileage = newValue;
  },
  setDays(state, newValue) {
    state.days = newValue;
  },
  setMiles(state, newValue) {
    state.miles = newValue;
  },
};

const state = {
  calcs: [{
    index: 0,
    days: 0,
    miles: 0,
    annualMileage: 0,
  },
  {
    index: 1,
    days: 0,
    miles: 0,
    annualMileage: 0,
  },
  {
    index: 2,
    days: 0,
    miles: 0,
    annualMileage: 0,
  },
  {
    index: 3,
    days: 0,
    miles: 0,
    annualMileage: 0,
  },
  {
    index: 4,
    days: 0,
    miles: 0,
    annualMileage: 0,
  },
  {
    index: 5,
    days: 0,
    miles: 0,
    annualMileage: 0,
  },
  {
    index: 6,
    days: 0,
    miles: 0,
    annualMileage: 0,
  },
  {
    index: 7,
    days: 0,
    miles: 0,
    annualMileage: 0,
  }],
};

export default {
  state,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/annualcalc.js